const all = ['specialities']
const list = () => [...all, 'list']

export const specialitiesKeys = {
  all,
  list,
}
